// test1079
(1079 && 0);
